export enum ActivityRole {
  Monitor = 'monitor',
  HeadMonitor = 'headMonitor',
  GamesMonitor = 'gamesMonitor',
  Teacher = 'teacher',
  RegionalManager = 'regionalManager',
}
